import * as React from 'react';
import { resultPicker } from 'Routes/Diagnosis/utils/FTD';
import { fm } from 'Components/FormatMessage';

const rows1 = ['criteriaForCertainFTDFulfilled', 'criteriaForProbableFTDFulfilled', 'criteriaForPossibleFTDFulfilled'];

const rows2 = ['coreCriteriaForFTDFulfilled', 'exclusionCriteriaForFTDFulfilled'];

const secondaryCriteriaToLocalizationSuffixMap = {
  yes: 'Fulfilled',
  no: 'NotFulfilled',
  unknown: 'Unknown',
};

const FTDDiagnosticCriteriaHistory = ({ d }: IOwnProps): React.JSX.Element => {
  const fulfilledCriteria = rows1.find(row => resultPicker(d, row) === 'yes');

  return (
    <React.Fragment>
      {!!fulfilledCriteria ? (
        <div>{fm(`diagnosis.ftd.summary.${fulfilledCriteria}`)}</div>
      ) : (
        rows2.map((row, i) => (
          <div key={i}>
            {fm(
              `diagnosis.ftd.summary.${row.split('ForFTD')[0]}${secondaryCriteriaToLocalizationSuffixMap[resultPicker(d, row)]}`,
            )}
          </div>
        ))
      )}
    </React.Fragment>
  );
};

interface IOwnProps {
  d: IFTD;
}

export default FTDDiagnosticCriteriaHistory;
